'use client'

import { Box, Typography, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

type FaqItem = {
    q: string;
    a: {
        title: string;
        description: string;
        note: string;
    }
}

type FaqSectionProps = {
    categoryTitle: string;
    items: FaqItem[];
    keyWord: string;
}

export default function FaqSection({ categoryTitle, items, keyWord }: FaqSectionProps) {
    return (
        <Box sx={{ mb: 8 }}>
            <Typography variant="h5" sx={{ fontWeight: 800, color: '#132c4b', mb: 3 }}>
                {categoryTitle}
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {items.map((item, index) => (
                    <Accordion
                        key={index}
                        elevation={0}
                        sx={{
                            border: '1px solid #e2e8f0',
                            borderRadius: '16px !important', // Force override default square corners
                            '&:before': { display: 'none' }, // Remove default divider
                            overflow: 'hidden',
                            mb: 0
                        }}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon sx={{ color: '#64748b' }} />}
                            sx={{
                                px: 3,
                                py: 1,
                                '& .MuiAccordionSummary-content': { my: 2 }
                            }}
                        >
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1e293b' }}>
                                {item.q}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ px: 3, pb: 4, pt: 0 }}>
                            {item.a.title && (
                                <Typography
                                    variant="body1"
                                    sx={{ color: '#1e293b', fontWeight: 'bold', lineHeight: 1.8 }}
                                    dangerouslySetInnerHTML={{ __html: item.a.title }}
                                />
                            )}
                            {item.a.description && (
                                <Typography
                                    variant="body1"
                                    sx={{ color: '#1e293b', lineHeight: 1.8 }}
                                    dangerouslySetInnerHTML={{ __html: item.a.description }}
                                />
                            )}
                            {item.a.note && (
                                <Typography
                                    variant="body1"
                                    sx={{ color: '#1e293b', lineHeight: 1.8, pt: 2 }}
                                    dangerouslySetInnerHTML={{ __html: '<strong>' + keyWord + '：</strong>' + item.a.note }}
                                />
                            )}
                        </AccordionDetails>
                    </Accordion>
                ))}
            </Box>
        </Box>
    );
}